var map = {
	"./dashboard-sidebar-desktop-en.jpg": "d601",
	"./dashboard-sidebar-desktop-fr.jpg": "6983",
	"./dashboard-sidebar-desktop-ru.jpg": "ec48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca5f";